export default __webpack_public_path__ + "static/media/DNo.31-4.eb7a16cc.jpg";